import { Component } from 'react';
import './App.css'

class EpiphaniesSmartLinks extends Component {
	render() {
		return (
			<div className="Smart-links">
				<iframe className="Smart-link-video"
                        src="https://www.youtube.com/embed/Y1U4rwfVS9k?si=V15UXq9qxrTZbtgA" title="Epiphanies I & II"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
				<div className="Smart-link-buttons">
					<a href="https://sheepdogwolf.bandcamp.com/track/epiphanies-i-ii"><btn className="Smart-link-button">bandcamp</btn></a>
					<a href="https://tidal.com/browse/track/454798480?u"><btn className="Smart-link-button">tidal</btn></a>
					<a href="https://link.deezer.com/s/314UuKMtoajBn8FpNS77d"><btn className="Smart-link-button">deezer</btn></a>
					<a href="https://music.apple.com/nz/album/epiphanies-i-ii-single/1834011581"><btn className="Smart-link-button">apple music</btn></a>
					<a href="https://open.spotify.com/track/5eqdggQLphpTo0xoCr5Ch3?si=c121b3762c7c4271"><btn className="Smart-link-button">spotify</btn></a>
					<div className="Spotify-notice">
					IF YOU ARE A SPOTIFY USER, PLEASE CONSIDER USING ANOTHER STREAMING SERVICE. <a href="https://www.cnbc.com/2025/06/17/spotifys-daniel-ek-leads-investment-in-defense-startup-helsing.html">THEIR CEO HEAVILY INVESTS IN AI WEAPONS TECH</a>. I DONATE MY SPOTIFY PROFITS TO MEDICAL AID FOR PALESTINIANS.
					</div>
				</div>
			</div>
		);
	}
}

export default EpiphaniesSmartLinks;